import axios from "axios";
// import { Toast } from "vant";
import { message } from "ant-design-vue";
import { removeAccessToken } from "./cookie";

// const protocol = window.location.protocol || "http";
const api =
  process.env.NODE_ENV === "production"
    ? `${process.env.VUE_APP_API_BASE_URL}`
    : "/api";
const service = axios.create({
  baseURL: api,
  withCredentials: true,
  timeout: 10000
});

// request interceptor
service.interceptors.request.use(
  request => {
    /*  const spot = window.localStorage.getItem('__shareid');
    Toast.fail(spot);
    if (spot) { */
    // eslint-disable-next-line no-param-reassign
    request.headers.spot = 1;
    // }
    return request;
  },
  error => {
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    const { code, data } = response.data;
    if (code === 200) return data;
    if (code === 401) {
      removeAccessToken();
      // window.location.href = data;
    }
    if (code === 400) {
      message.error(response.data.msg);
      return false;
    }
    return false;
  },
  error => {
    // Toast.fail(error);
    message.error(error);

    Promise.reject(error);
  }
);

export default service;
